import { render } from "./UsuariosnewForm.vue?vue&type=template&id=31de0a77&scoped=true"
import script from "./UsuariosnewForm.vue?vue&type=script&lang=js"
export * from "./UsuariosnewForm.vue?vue&type=script&lang=js"

import "./UsuariosnewForm.vue?vue&type=style&index=0&id=31de0a77&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\Arenal\\ViajesControl\\Arenal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31de0a77"]])

export default __exports__